"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontWeight = void 0;
exports.fontWeight = {
    regular: 400,
    medium: 500,
    semibold: 600,
};
